import { db } from '@app/icare/client/db'
import { localResultQueryOptions } from '@app/icare/client/db/client/localQueryOptions'
import type { PatientIdType } from '@app/icare/entities/patient/schema/PatientId'

export const patientMobilityQueries = {
  forList: (patientId: PatientIdType) =>
    localResultQueryOptions({
      meta: { scope: { patientId: String(patientId), tags: ['patientMobility'] } },
      query: db
        .selectFrom('patientMobility')
        .selectAll()
        .where('patientId', '=', patientId)
        .where('deletedAt', 'is', null)
        .orderBy('activeFrom', 'desc'),
    }),
}
